import { Carousel } from "antd";
import './Works.scss';
import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import series from '../../data/series.json';
import EmailIcon from '../EmailIcon';
import NotFound from '../../pages/NotFound/NotFound';

const imgSrc = path => path.split('/').map(encodeURIComponent).join('/');

const allWorks = series.flatMap(s => s.works.map(w => ({ ...w, seriesName: s.name })));

function Work() {
    const { id } = useParams();
    const navigate = useNavigate();
    const work = allWorks.find(w => w.id === Number(id));

    const [invalidSrcs, setInvalidSrcs] = useState(new Set());
    const markInvalid = src => setInvalidSrcs(prev => new Set([...prev, src]));

    if (!work) {
        return <NotFound />;
    }

    const slides = [
        { key: 'main', src: work.main, alt: work.title },
        ...(work.type !== 'flower' && work.interior
            ? [{ key: 'interior', src: work.interior, alt: `${work.title} — in situ` }]
            : []),
        ...(work.parts || []).map((part, i) => ({
            key: `part-${i}`,
            src: part,
            alt: `${work.title} — detail ${i + 1}`,
        })),
    ].filter(slide => !invalidSrcs.has(slide.src));

    return (
        <div className='work-detail'>
            <div className='work-detail-inner'>
                <div className='work-carousel'>
                    <Carousel key={`${work.id}-${slides.length}`} initialSlide={0} arrows={false} infinite autoplay autoplaySpeed={4000}>
                        {slides.map(slide => (
                            <div key={slide.key} className='carousel-slide'>
                                <img
                                    alt={slide.alt}
                                    src={imgSrc(slide.src)}
                                    onError={() => markInvalid(slide.src)}
                                />
                            </div>
                        ))}
                    </Carousel>
                </div>

                <div className='work-info'>
                    <span className='work-info-eyebrow'>{work.seriesName}</span>
                    <h2 className='work-info-title'>{work.title}</h2>
                    <p className='work-info-description'>{work.medium} · {work.dimensions} · {work.year}</p>

                    <div className='work-info-meta'>
                        <div className='work-info-meta-row'>
                            <span className='meta-label'>Medium</span>
                            <span className='meta-value'>{work.medium}</span>
                        </div>
                        <div className='work-info-meta-row'>
                            <span className='meta-label'>Dimensions</span>
                            <span className='meta-value'>{work.dimensions}</span>
                        </div>
                        <div className='work-info-meta-row'>
                            <span className='meta-label'>Year</span>
                            <span className='meta-value'>{work.year}</span>
                        </div>
                    </div>

                    <div className='work-info-divider' />

                    <div className='work-info-note'>
                        Each work is carefully packaged for safe delivery worldwide.
                    </div>

                    <div className='work-info-actions'>
                        <button className='work-inquire-btn' onClick={() => window.location.href = 'mailto:annahovann@gmail.com?subject=Inquiry: ' + work.title}>
                            <EmailIcon size={16} />
                            Inquire About This Work
                        </button>
                        <button className='work-back-btn' onClick={() => navigate('/works')}>← Back to Works</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Work;
